<template>
    <Box padding="none" :radius="isTablet ? 's' : 'none'">
        <div class="sembonus-nights">
            <div class="sembonus-nights-illustration">
                <Illustration
                    :data="{ type: 'Discount3', primary: 'violet', accent: 'purple' }" />
            </div>

            <div class="sembonus-nights-content">
                <Info />
                <Selection />
            </div>
        </div>
    </Box>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { useScreenSize } from '@shared/helpers/viewport';
    import Box from '@ui/components/Box/Box.vue';
    import Selection from './Selection/Selection.vue';
    import Illustration from '@ui/components/Illustration/Illustration.vue';
    import Info from '../Shared/Info/Info.vue';

    export default defineComponent({
        name: 'Nights',
        components: { Box, Selection, Info, Illustration },
        setup() {
            const { isTablet } = useScreenSize();
            return { isTablet };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'Nights';
</style>
